import { TruncatedTextCell } from "@trafficsharkdsp/ui";
import cl from "classnames";

import cls from "./CampaignSelector.module.css";

import { ModelsCampaignV2Model } from "@/schemas";
import { getStoreType } from "@/shared/lib/detectStoreFromUrl";
import { AppIconPreview } from "@/shared/ui/AppIconPreview/AppIconPreview";

interface CampaignLabelProps {
    campaign: ModelsCampaignV2Model;
    showStatusMark?: boolean;
}

export const CampaignLabel = (props: CampaignLabelProps) => {
    const { campaign, showStatusMark = false } = props;
    const app = campaign.target?.app;
    return (
        <div className={cls.label}>
            {app && (
                <AppIconPreview iconLink={app.icon_link} platform={getStoreType(app)} compact />
            )}
            {showStatusMark && campaign.status && (
                <span
                    className={cl(
                        cls["status-mark"],
                        cls[`status-${campaign.status.toLowerCase()}`],
                    )}
                    title={campaign.status}
                />
            )}
            <TruncatedTextCell className={cls.name}>
                <span className={cls.title}>{campaign.name || "No title"}</span>
                <TruncatedTextCell className={cls.id}>{campaign.uuid}</TruncatedTextCell>
            </TruncatedTextCell>
        </div>
    );
};
